/*import React from "react";

const Privacypolicy = () => {
  return (
    <div className="max-w-5xl mx-auto leading-8">
      <h1 style={{ fontWeight: 600, fontSize: 28 }}>Privacy Policy</h1>
      <p className="text-start">
        THESE TERMS AND CONDITIONS OUTLINE THE RULES AND REGULATIONS FOR THE USE
        OF WOW CARZ PRIVATE LIMITED’S WEBSITE www.wow carz.in HCUBE WOW CARZ
        PRIVATE LIMITED HAVING RESISTERED OFFICE SITUATED AT No:1029 ,17th 2nd
        Block, BTM 4th stage, Arekere, Bangalore Pin code: 5670076
      </p>

      <strong className="text-start">
        PLEASE READ THE TERMS OF MEMBER AGREEMENT CAREFULLY BEFORE USING OR
        REGISTERING ON THE WEBSITE OR ACCESSING ANY MATERIAL, INFORMATION OR
        AVAILING SERVICES THROUGH THE WEBSITE. IF YOU DO NOT AGREE WITH THESE
        TERMS, PLEASE DO NOT USE THE WEBSITE OR AVAIL ANY SERVICES BEING OFFERED
        THROUGH THE WEBSITE.
      </strong>

      <p className="text-start  my-8">
        BY ACCESSING THIS WEBSITE, WE ASSUME YOU HAVE AGREED TO THESE TERMS AND
        CONDITIONS IN FULL.
      </p>

      <p className="text-start">
        “Applicable Law(s)” means any MVT Law and other statute, law,
        regulation, ordinance, rule, judgment, order, decree, bye-law,
        clearance, directive, guideline, policy, requirement, or other
        governmental restriction or any similar form of, decision of, or
        determination by, or any interpretation, policy or administration having
        the force of law of any of the foregoing, by any government authority
        having jurisdiction over the matter in question, whether in effect as of
        the date of these Terms and Conditions or thereafter. “MVT Laws” means
        collectively, the Motor Vehicles Act, 1988 and the Rules made the
        reunder, or any other statutory modification amendment or re-enactment
        thereof “Reservation Details” means the reservation details of the Hirer
        and details of the Vehicle hereunder written “Schedule of Charges” means
        the charges which may be levied by the Hirer and more particularly
        described in the Schedule hereunder written “Vehicle” means a vehicle or
        vehicles hired by the Hirer pursuant to these Terms and Conditions
      </p>

      <h1 style={{ fontWeight: 500, fontSize: 24 }} className="text-start">Providing Vehicle on Rental :</h1>
      <ui className="list-decimal text-start my-8">
        <li>
          Upon receipt of the booking request by client from the Hirer through
          its Website / Telephone, client has provided the Vehicle/s for hire to
          the Hirer for his / her bonafide personal and/or official use as
          indicated in booking request on a day mentioned in the Reservation
          Details
        </li>
        <li>
          Hirer, himself / herself, shall drive the Vehicle and that he / she is
          not authorized to assign/sub-let/license the Vehicle or its use to any
          other person whomsoever. If the Vehicle is supposed to be driven by
          any other person then the Hirer shall ensure that such driver is
          holding a valid driving license and the Hirer shall provide details of
          any such additional driver.
        </li>

        <li>
          The Hirer shall be solely responsible for payment of any and all toll
          or other road / parking charges /interstate permit charges, as
          applicable, during usage of Vehicle during Hire Period.
        </li>
        <li>
          The Vehicle shall be used strictly in accordance with the procedure
          prescribed by the manufacturer of the Vehicle in the Manufacturer’s
          manual supplied along with the Vehicle and also strictly in accordance
          with applicable Law
        </li>
        <li>
          The Hirer is not permitted to use / drive the Vehicle :
          <ui className="text-start my-8 mx-auto list-disc">
            <li>
              To carry number of persons (excluding the driver) exceeding the
              permissible number as specified in MVT Law
            </li>
            <li>
              To ferry passengers or any goods for consideration or reward
              whether expressed or implied.
            </li>

            <li>To ferry pets or any type of animals.</li>

            <li>
              To carry any contraband, hazardous or inflammable material,
              firearms or other band or prohibited articles under Indian laws.
            </li>
            <li>For any illegal or unlawful activity or purpose.</li>
            <li>
              In any motor sport event of any kind including but not limited to
              racing, or rallying or for the purpose of learning driving of
              Vehicles or taking or giving driving lessons, speed testing or any
              other similar activities causing damage to the Vehicle
            </li>
            <li>To propel or tow any other vehicle or trailer.</li>
            <li>Beyond the speed limit of 100 Kms/per hour.</li>
            <li>
              Under the influence of alcohol or drugs or sufferance of any
              disease or disability, which may cause his / her driving ability
              or which is likely to cause a source of danger to the public
              and/or to the Vehicle. For undertaking road trip specifically for
              any reward / award or for creating any record or recognitions of
              any nature whatsoever.
            </li>
          </ui>
        </li>
        <li>
          The Hirer shall be liable to pay the stipulated charges as mentioned
          in the Schedule of Charges, if the Hirer or any other person
          authorized by him / her fails to observe the terms of usage of Vehicle
          as stated in para 5 above.
        </li>
      </ui>

      <h1 style={{ fontWeight: 500, fontSize: 24 }} className="text-start my-8">General Terms :</h1>
      <ul className="list-decimal text-start my-8">
        <li>
          The Hirer intending to enter into this Agreement and rent the vehicle
          on self drive basis should have attained 21 years of age and shall
          have a driving experience of a minimum of 1 year in addition to
          submission of a valid driving license, voter ID/Passport and credit
          card details to the client. The Hirer takes the Vehicle on hire at his
          own risk and the Hirer shall be solely liable for any accident,
          failure or loss or damage of any kind whatsoever that may be caused to
          or occasioned by the Hirer in connection with or incidental to the
          provision of the Rent-A-Cab services on a self drive basis. Client
          shall not be liable for any loss, damage, costs, charges or expenses
          whatsoever that may be caused to or occasioned by the Hirer or any
          other person seated in the Vehicle.
        </li>
        <li>
          The Hirer shall not make any addition or alteration to the Vehicle or
          carry out or replace any parts of the Vehicle. The Hirer shall ensure
          that distinguishing marks carried or exhibited in or on the Vehicle is
          / are not removed and that he / she shall not tamper with or damage
          the odometer or any other accessories fitted in the Vehicle and in
          case it is done, the Hirer shall be solely liable to replace the same
          at his / her own cost and consequences and also be liable for payment
          of charges as stipulated in the Schedule of Charges and any other
          charges incidental and ancillary thereto.
        </li>
      </ul>

      <h1 style={{ fontWeight: 500, fontSize: 24 }} className="text-start">The Hirer represents and warrants that:</h1>
      <ui className="list-decimal text-start my-8">
        <li>
          He/she shall supply true, valid, authenticate and accurate information
          and documents such as identity proof and address proof on or before
          the commencement of Hire Period.
        </li>
        <li>
          He/she shall not transfer, assign or otherwise dispose of or purport
          to transfer, assign or dispose of the Vehicle by way of mortgage,
          charge, sublease, sale or other assignment, hypothecation, pledge,
          hire, encumbrance, license or otherwise in any manner part with the
          possession of the Vehicle or any part thereof or allow or purport to
          do or allow or create any lien, charge, attachment or other claim of
          whatsoever nature on the Vehicle or any part thereof.
        </li>
        <li>
          He/she shall not make any major additions/alterations to the Vehicle
          which affects the marketability of the Vehicle.
        </li>
        <li>
          He/she shall use and operate the Vehicle in the manner specified in
          Manufacturer Manual and also ensure that the Hirer has a valid driving
          license to ply the Vehicle and keep the same effective and in force at
          all times during the period of this agreement and till the Vehicle is
          delivered back to the owner in good order and condition.
        </li>
        <li>
          He/she shall use the Vehicle for the purpose as indicated in booking
          request and specified in Reservation Details and shall not use it for
          any commercial or illegal activity or purpose which is prohibited by
          Indian laws.
        </li>
      </ui>

      <p className="text-start">
        He/She shall not breach any of the terms and conditions of this
        Agreement either intentionally or unintentionally or endangered the
        Vehicle.
      </p>

      <h1 style={{ fontWeight: 500, fontSize: 24 }} className="text-start">Remedies to the Owner:</h1>
      <p className="text-start">
        In case of an event of default occurs, the Owner may without notice,
        repossess the Vehicle and for such purpose may enter upon the premises
        where the Vehicle may have been parked and remove/repossess the same and
        the Hirer shall be responsible for and indemnify owner against all
        actions, claims, costs and damages consequent upon or arising from such
        repossession and removal.
      </p>

      <h1 style={{ fontWeight: 500, fontSize: 24 }} className="text-start">Indemnity:</h1>
      <p className="text-start">
        That Hirer shall indemnify and keep indemnified the owner, its
        directors, officers, from and against:
      </p>
      <ul className="text-start">
        <li>
          Any third party loss and/or damage/ claim caused by the Hirer during
          the Hire Period.
        </li>
        <li>Any third party property loss.</li>
        <li>
          Any loss, theft and damage caused to the Vehicle and /or Owners
          property during the Hire Period.
        </li>
        <li>
          Any claim and/or action as result of violation of laws, rules and
          statutes.
        </li>
        <li>
          Any loss and/or damages caused to Owner’s vehicle consequent to any
          misrepresentation and/or fraud and/or breach of the terms and
          condition of this Agreement.
        </li>
      </ul>

      <h1 style={{ fontWeight: 500, fontSize: 24 }} className="text-start">Miscellaneous Terms :</h1>
      <p className="text-start">
        The Owner reserves the right to use and share user documents and user
        data on any third party websites and government agency portals for the
        purpose of verification and authentication of the submitted documents.
      </p>
      <p className="text-start">
        Administrative and Legal Reasons: the owner cooperates with government
        and law enforcement officials and private parties and helps to enforce
        and comply with the law. Thus, the owner may access, use, preserve,
        transfer and disclose any information (including personal information)
        provided by the Hirer to any government or law enforcement officials or
        private parties as Owner may reasonably determine is necessary and
        appropriate:
      </p>
      <ul className="text-start">
        <li>
          To satisfy any applicable law, regulation, subpoenas, governmental
          requests or legal process.
        </li>
        <li>
          To protect the safety, rights, property or security of Owner, Owner
          services or any third party.
        </li>
        <li>To protect the safety of the public for any reason.</li>

        <li>
          To detect, prevent or otherwise address fraud. Such disclosures may be
          carried out without notice to the Hirer.
        </li>
      </ul>

      <h1 style={{ fontWeight: 500, fontSize: 24 }} className="text-start">Notice:</h1>
      <p className="text-start">
        All notices, demands or other communications required to be given or
        made hereunder shall be in writing and delivered personally or sent by
        prepaid registered post or facsimile transmission, or email addressed to
        the intended recipient thereof at its address or facsimile number, email
        address is given below or to such address or facsimile number or email
        address as any party may from time to time notify other parties.
      </p>

      <h1 style={{ fontWeight: 500, fontSize: 24 }} className="text-start">Governing Laws:</h1>
      <ul className="text-start">
        <li>
          This agreement shall be governed by, construed and interpreted in
          accordance with the laws of India.
        </li>
      </ul>

      <p className="text-start">
        If any term or provision of this Agreement is declared invalid by a
        court of competent jurisdiction, the remaining terms and provisions of
        this agreement shall remain unimpaired and in full force and effect.
      </p>

      <h1  style={{ fontWeight: 500, fontSize: 24 }} className="text-start">Contact us:</h1>
      <p className="text-start">
        If there are any questions regarding this privacy policy, you may
        contact us using the information below.
      </p>
    </div>
  );
};

export default Privacypolicy;*/

import React from "react";

const Privacypolicy = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 md:px-8 py-10 leading-8 text-gray-700">
      <div className="p-6 md:p-10">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center">
          Privacy Policy
        </h1>

        <p className="text-start text-base md:text-lg mb-6">
          THESE TERMS AND CONDITIONS OUTLINE THE RULES AND REGULATIONS FOR THE USE
          OF WOW CARZ PRIVATE LIMITED'S WEBSITE <b>www.wowcarz.in HCUBE WOW CARZ
          PRIVATE LIMITED</b>, HAVING ITS REGISTERED OFFICE AT No: <b>1029, 17th Main,
          2nd Block, BTM 4th Stage, Arekere, Bangalore – 560076.</b>
        </p>

        <div className="bg-amber-50 border-l-4 border-amber-500 p-5 rounded-r-xl mb-8">
          <strong className="block text-start text-gray-800">
            PLEASE READ THE TERMS OF MEMBER AGREEMENT CAREFULLY BEFORE USING OR
            REGISTERING ON THE WEBSITE OR ACCESSING ANY MATERIAL, INFORMATION, OR
            AVAILING SERVICES THROUGH THE WEBSITE. IF YOU DO NOT AGREE WITH THESE
            TERMS, PLEASE DO NOT USE THE WEBSITE OR AVAIL ANY SERVICES OFFERED
            THROUGH THE WEBSITE.
          </strong>
        </div>

        <p className="text-start my-8 text-base md:text-lg">
          BY ACCESSING THIS WEBSITE, WE ASSUME YOU HAVE AGREED TO THESE TERMS AND
          CONDITIONS IN FULL.
        </p>

        <p className="text-start mb-8">
          “Applicable Law(s)” means any MVT Law and other statute, law,
          regulation, ordinance, rule, judgment, order, decree, bye-law,
          clearance, directive, guideline, policy, requirement, or other
          governmental restriction or any similar form of decision or
          determination by any government authority having jurisdiction over the
          matter in question. “MVT Laws” means collectively, the Motor Vehicles
          Act, 1988 and the Rules made thereunder, including any statutory
          modification, amendment, or re-enactment thereof. “Reservation
          Details” means the reservation details of the Hirer and details of the
          Vehicle. “Schedule of Charges” means the charges that may be levied by
          the Hirer and are more particularly described in the applicable
          schedule. “Vehicle” means a vehicle or vehicles hired by the Hirer
          pursuant to these Terms and Conditions.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-6 text-start border-b pb-2">
          Providing Vehicle on Rental
        </h2>
        <ol className="list-decimal pl-6 space-y-4 text-start mb-8">
          <li>
            Upon receipt of the booking request by the Hirer through the Website
            or telephone, the company shall provide the Vehicle(s) for hire for
            bona fide personal and/or official use as indicated in the booking
            request.
          </li>
          <li>
            The Hirer shall personally drive the Vehicle and is not authorized
            to assign, sub-let, or license its use to any other person. If an
            additional driver is permitted, the Hirer must provide details and
            ensure such driver holds a valid driving license.
          </li>
          <li>
            The Hirer shall be solely responsible for payment of all tolls,
            parking charges, interstate permit charges, and any other road usage
            fees during the Hire Period.
          </li>
          <li>
            The Vehicle shall be used strictly in accordance with the
            manufacturer's manual and all applicable laws.
          </li>
          <li>
            The Hirer is not permitted to use or drive the Vehicle:
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>
                To carry passengers exceeding the permissible capacity under law.
              </li>
              <li>
                To ferry passengers or goods for consideration or reward.
              </li>
              <li>To transport pets or animals of any kind.</li>
              <li>
                To carry contraband, hazardous or inflammable materials,
                firearms, or prohibited articles.
              </li>
              <li>For any illegal or unlawful activity.</li>
              <li>
                In racing, rallying, speed testing, driving lessons, or similar
                activities.
              </li>
              <li>To tow or propel another vehicle or trailer.</li>
              <li>Beyond the speed limit of 100 km/h.</li>
              <li>
                Under the influence of alcohol, drugs, or any condition that may
                impair safe driving.
              </li>
            </ul>
          </li>
          <li>
            The Hirer shall be liable for all stipulated charges if the terms of
            vehicle usage are violated.
          </li>
        </ol>

        <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-6 text-start border-b pb-2">
          General Terms
        </h2>
        <ol className="list-decimal pl-6 space-y-4 text-start mb-8">
          <li>
            The Hirer must be at least 21 years old, possess a valid driving
            license, have a minimum of one year of driving experience, and
            provide valid identity proof, address proof, and credit card
            details.
          </li>
          <li>
            The Hirer shall not make any additions, alterations, or replacements
            to the Vehicle, nor tamper with the odometer or any accessories.
          </li>
        </ol>

        <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-6 text-start border-b pb-2">
          The Hirer Represents and Warrants That
        </h2>
        <ol className="list-decimal pl-6 space-y-4 text-start mb-8">
          <li>
            All information and documents provided shall be true, valid,
            authentic, and accurate.
          </li>
          <li>
            The Hirer shall not transfer, assign, mortgage, pledge, sublease, or
            otherwise encumber the Vehicle.
          </li>
          <li>
            No major additions or alterations affecting the Vehicle's
            marketability shall be made.
          </li>
          <li>
            The Vehicle shall be operated strictly as per the manufacturer's
            manual and applicable laws.
          </li>
          <li>
            The Vehicle shall be used only for the purpose specified in the
            booking request and not for any illegal or commercial purpose.
          </li>
        </ol>

        <p className="text-start mb-8">
          He/She shall not breach any of the terms and conditions of this
          Agreement, whether intentionally or unintentionally, nor endanger the
          Vehicle.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-6 text-start border-b pb-2">
          Remedies to the Owner
        </h2>
        <p className="text-start mb-8">
          In the event of default, the Owner may, without notice, repossess the
          Vehicle. The Hirer shall indemnify the Owner against all actions,
          claims, costs, and damages arising from such repossession.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-6 text-start border-b pb-2">
          Indemnity
        </h2>
        <p className="text-start mb-4">
          The Hirer shall indemnify and keep indemnified the Owner, its
          directors, and officers against:
        </p>
        <ul className="list-disc pl-6 space-y-3 text-start mb-8">
          <li>Any third-party loss, damage, or claim.</li>
          <li>Any third-party property loss.</li>
          <li>Loss, theft, or damage to the Vehicle or Owner's property.</li>
          <li>Claims arising from violation of laws, rules, or statutes.</li>
          <li>
            Losses arising from misrepresentation, fraud, or breach of this
            Agreement.
          </li>
        </ul>
        <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-6 text-start border-b pb-2">
          Collection of Location Data
        </h2>
        <div className="space-y-4 text-start mb-8">
          <ol className="list-decimal pl-6 space-y-4 text-start mb-8"><li><strong>What we collect:</strong> We collect your precise or approximate location via GPS, IP address, or Wi‑Fi signals.</li>
          <li><strong>Why we collect it:</strong> To verify your proximity to a vehicle, calculate trip distances, and ensure service availability in your region.</li>
          <li><strong>Storage:</strong> This data is stored securely on our servers and is deleted 30 days after your rental ends.</li>
          <li><strong>Your Choice:</strong> You can disable location tracking at any time through your browser settings or device permissions.</li></ol>
        </div>
        <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-6 text-start border-b pb-2">
          Miscellaneous Terms
        </h2>
        <p className="text-start mb-4">
          The Owner reserves the right to use and share user documents and data
          with third-party websites and government agencies for verification and
          authentication purposes.
        </p>
        <p className="text-start mb-4">
          The Owner may access, use, preserve, transfer, and disclose
          information where reasonably necessary to:
        </p>
        <ul className="list-disc pl-6 space-y-3 text-start mb-8">
          <li>Comply with applicable laws, regulations, or legal processes.</li>
          <li>Protect the safety, rights, and property of the Owner.</li>
          <li>Protect public safety.</li>
          <li>Detect, prevent, or address fraud.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-6 text-start border-b pb-2">
          Notice
        </h2>
        <p className="text-start mb-8">
          All notices, demands, or communications shall be in writing and may be
          delivered personally, by prepaid registered post, facsimile, or email
          to the address provided by the relevant party.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-6 text-start border-b pb-2">
          Governing Laws
        </h2>
        <ul className="list-disc pl-6 space-y-3 text-start mb-8">
          <li>
            This Agreement shall be governed by and construed in accordance with
            the laws of India.
          </li>
        </ul>

        <p className="text-start mb-8">
          If any provision of this Agreement is declared invalid by a court of
          competent jurisdiction, the remaining provisions shall remain in full
          force and effect.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-6 text-start border-b pb-2">
          Contact Us
        </h2>
        <p className="text-start">
          If you have any questions regarding this Privacy Policy, please contact
          us using the information provided on our website.
        </p>
      </div>
    </div>
  );
};

export default Privacypolicy;

